// extracted by mini-css-extract-plugin
export var categories = "Categories-module--categories--rc8uf";
export var categories__container = "Categories-module--categories__container--j1SFg";
export var categories__container__button = "Categories-module--categories__container__button--mfnUh";
export var categories__container__button__close = "Categories-module--categories__container__button__close--3dMGr";
export var categories__container__link = "Categories-module--categories__container__link--VgJum";
export var categories__container__list = "Categories-module--categories__container__list--7gkV5";
export var categories_opened = "Categories-module--categories_opened--qquX7";